/*
 * Lead forms (snippets/lead-form.liquid). Vanilla port of the submit logic in
 * src/components/LeadForm.tsx: same payload, same checks, same messages.
 * Posts cross-origin to the Vercel lead route, which allows instasculpting.com
 * (see the CORS block in src/app/api/lead/route.ts).
 */
(function () {
  function collectUtm() {
    var out = {};
    var params = new URLSearchParams(window.location.search);
    params.forEach(function (v, k) {
      if (/^utm_[a-z]+$|^gclid$|^fbclid$/i.test(k)) out[k] = v;
    });
    return out;
  }

  function wire(form) {
    var panel = form.closest('[data-lead-panel]');
    var note = panel.querySelector('[data-lead-note]');
    var done = panel.querySelector('[data-lead-done]');
    var button = form.querySelector('button[type="submit"]');
    var endpoint = form.getAttribute('data-endpoint');

    function fail(msg) {
      note.textContent = msg;
      note.setAttribute('role', 'alert');
      button.disabled = false;
      button.textContent = button.getAttribute('data-label');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      var get = function (k) {
        var v = fd.get(k);
        return typeof v === 'string' ? v : '';
      };
      if (!get('email') && !get('phone')) {
        fail('Please give us an email or a phone number so we can reach you.');
        return;
      }
      button.disabled = true;
      button.textContent = 'Sending…';
      note.removeAttribute('role');
      note.textContent = note.getAttribute('data-default');

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          firstName: get('firstName'),
          lastName: get('lastName'),
          company: get('company'),
          email: get('email'),
          phone: get('phone'),
          businessType: get('businessType'),
          smsConsent: fd.get('smsConsent') === 'on',
          website: get('website'),
          formId: form.getAttribute('data-form-id') || 'request-pricing',
          page: window.location.pathname,
          utm: collectUtm(),
        }),
      })
        .then(function (r) {
          return r
            .json()
            .catch(function () {
              return {};
            })
            .then(function (data) {
              if (!r.ok || !data.ok) {
                fail(data.error || 'Something went wrong. Please call us.');
                return;
              }
              form.hidden = true;
              note.hidden = true;
              var head = panel.querySelector(':scope > h3');
              var sub = panel.querySelector(':scope > p:not([data-lead-note])');
              if (head) head.hidden = true;
              if (sub) sub.hidden = true;
              done.hidden = false;
            });
        })
        .catch(function () {
          fail('Could not send. Please check your connection or call us.');
        });
    });
  }

  document.querySelectorAll('form[data-lead-form]').forEach(wire);
})();
